import { Edge } from "@xyflow/react";
import { atom } from "jotai";

export const edgesAtom = atom<Edge[]>([]);

edgesAtom.debugLabel = "edgesAtom";
